import { validation } from 'validate';
export const personalInfoValidation = (values) => {
    const errors = {};

    const firstNameValidate = validation(values.first_name, 'First Name', true);
    const lastNameValidate = validation(values.last_name, 'Last Name', true);
    const positionValidate = validation(values.position, 'Position', true);
    const phoneValidate = validation(values.phone_number, 'Company Phone', true);
    const meetingLinkValidate = validation(values.meeting_link, 'Meeting Link', true, 'url');

    if (!firstNameValidate.isValid) errors.fullName = firstNameValidate.errorMessage;
    if (!lastNameValidate.isValid) errors.fullName = lastNameValidate.errorMessage;
    if (!positionValidate.isValid) errors.position = positionValidate.errorMessage;
    if (!phoneValidate.isValid) errors.phone_number = phoneValidate.errorMessage;
    if (!meetingLinkValidate.isValid) errors.meetingLink = meetingLinkValidate.errorMessage;

    return errors;
};

export const socialMediaValidation = (values) => {
    const errors = {};
    const urlPattern = /^https?:\/\/(?:www\.)?[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]+$/;

    const platforms = {
        linkedin_link: 'LinkedIn',
        x_link: 'Twitter (X)',
        facebook_link: 'Facebook',
        instagram_link: 'Instagram',
    };

    Object.entries(platforms).forEach(([field, label]) => {
        const value = values[field];

        if (field === 'linkedin_link') {
            if (!value) {
                errors[field] = `${label} link is required`;
            } else if (!urlPattern.test(value)) {
                errors[field] = `Enter a valid ${label} URL`;
            }
        } else if (value && !urlPattern.test(value)) {
            errors[field] = `Enter a valid ${label} URL`;
        }
    });

    return errors;
};
